<template>
  <div>
    <v-layout>
      <v-flex>
        <v-tabs
          grow
          v-model="activeTab"
          :show-arrows="false"
          color="cardgray"
          slider-color="primary"
          >
          <v-tab 
            v-for="tab in tabs" 
            :key="tab.title" 
            :href="`#${tab.title}`" 
            >
            {{ tab.title }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="activeTab">

          <v-tab-item :id="`Description`">
            <v-card>
              <challenge-description></challenge-description>
            </v-card>
          </v-tab-item>

          <v-tab-item :id="`Evaluation`">
            <v-card>
              <challenge-evaluation></challenge-evaluation>
            </v-card>
          </v-tab-item>

          <v-tab-item :id="`Awards`">
            <v-card>
              <challenge-awards></challenge-awards>
            </v-card>
          </v-tab-item>

<!--           <v-tab-item :id="`Timeline`">
            <v-card>
              <challenge-timeline></challenge-timeline>
            </v-card>
          </v-tab-item> -->

        </v-tabs-items>

      </v-flex>
    </v-layout>
  </div>

</template>

<script>
  import ChallengeDescription from './ChallengeDescription'
  import ChallengeEvaluation from './ChallengeEvaluation'
  import ChallengeAwards from './ChallengeAwards'
  // import ChallengeTimeline from './ChallengeTimeline'

  export default {
    name: 'Challenge',
    components: {
      'challenge-description': ChallengeDescription,
      'challenge-evaluation': ChallengeEvaluation,
      'challenge-awards': ChallengeAwards
      // 'challenge-timeline': ChallengeTimeline
      // 'challenge-rules': ChallengeRules
    },
    data () {
      return {
        activeTab: 'Description',  // by default start with description
        // activeTab: this.$route.fullPath,
        tabs: [
          { route: '/challenge-description', title: 'Description', key: 1 },
          { route: '/challenge-evaluation', title: 'Evaluation', key: 2 },
          { route: '/challenge-awards', title: 'Awards', key: 3 }
          // { route: '/challenge-timeline', title: 'Timeline', key: 4 }
          // { route: 'challenge-description', title: 'Rules' }
        ],
        route2tab: {
          '/challenge-description': 'Description',
          '/challenge-evaluation': 'Evaluation',
          '/challenge-awards': 'Awards'
          // '/challenge-timeline': 'Timeline'
        }
        // routeName: this.$route.params.name
      }
    },
    watch: {
      '$route.path': function (incomingPath) {
        this.activeTab = this.route2tab[incomingPath]
      }
    },
    // beforeRouteUpdate(to) {
    //   this.routename = to.params.name
    // },
    created () {
      // console.log('Challenge (base) component mounted')
      // console.log('this.activeTab: ' + this.activeTab)
      // var incomingPath = this.$route.path
      // console.log('incomingPath: ' + incomingPath)
      // console.log('activeTab: ' + this.activeTab)
      // console.log('this.$route.path: ' + incomingPath)
      // console.log('route2tab: ' + this.route2tab[incomingPath])
      // this.activeTab = this.route2tab[incomingPath]
      // console.log('route2tab[incomingPath: ' + this.route2tab[incomingPath])
      // console.log('activeTab: ' + this.activeTab)
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Challenge/Challenge.vue